import AutoSuite from './auto-suite';

/**
 * 单行输入框
 * @type {string}
 */
export const TextField = 'TextField';
/**
 * 数字输入框
 * @type {string}
 */
export const NumberField = 'NumberField';
/**
 * 多行输入框
 * @type {string}
 */
export const TextareaField = 'TextareaField';
/**
 * 单选框
 * @type {string}
 */
export const SelectField = 'SelectField';
/**
 * 金额
 * @type {string}
 */
export const MoneyField = 'MoneyField';
/**
 * 日期
 * @type {string}
 */
export const DateField = 'DateField';
/**
 * 地点
 * @type {string}
 */
export const TimeAndLocationField = 'TimeAndLocationField';
/**
 * 日期区间
 * @type {string}
 */
export const DateRangeField = 'DateRangeField';
/**
 * 关联审批单
 * @type {string}
 */
export const RelateField = 'RelateField';
/**
 * 明细
 * @type {string}
 */
export const TableField = 'TableField';
/**
 * 报价单
 * @type {string}
 */
export const PurchaseQuotedPriceField = 'PurchaseQuotedPriceField';


const Mixins = {
    data: () => ({}),
    created() {
    },
    mixins: [AutoSuite],
    methods: {

        /**
         * 初始表单数据
         * @param val 最终要展示的组件数组
         * @param oval 源组件数据
         * @param detailData 内容数据
         */
        initFormValue(val, oval, detailData) {
            for (let i = 0; i < oval.length; i++) {
                let cmpt = oval[i];
                let valueData = null;
                if (detailData && detailData[cmpt.props.id]) {
                    valueData = detailData[cmpt.props.id];
                }
                val.push(this.initComponent(cmpt, valueData));
            }
            console.log('initFormValue', val, oval, detailData);
        },

        /**
         * 初始化value字段的循环方法
         * @param cmpt
         * @param valueData
         * @returns {*}
         */
        initComponent(cmpt, valueData) {
            console.log('initComponent', cmpt.props.label, cmpt.props.id, valueData);
            if (cmpt.componentName == TableField) { //明细
                let children = _.cloneDeep(cmpt.children);
                cmpt.children = [];
                if (valueData && valueData.length > 0) {
                    for (let j = 0; j < valueData.length; j++) {
                        let temp = [];
                        this.initValue(temp, _.cloneDeep(children), valueData[j]);
                        cmpt.children.push(temp);
                    }
                } else {
                    let temp = [];
                    this.initValue(temp, _.cloneDeep(children), null);
                    cmpt.children.push(temp);
                }
            } else {
                let isSuite = this.isSuiteCompnent(cmpt.componentName);
                console.log('isSuiteCompnent', cmpt.componentName, isSuite);
                if (isSuite) { //套件
                    console.log('isSuiteCompnent success !!!!!!!');
                    let children = _.cloneDeep(cmpt.children);
                    cmpt.children = [];
                    for (let i = 0; i < children.length; i++) {
                        let childCmpt = children[i];
                        let childValueData = null;
                        if (valueData && valueData[childCmpt.props.id]) {
                            childValueData = valueData[childCmpt.props.id];
                        }
                        console.log(cmpt.componentName, childCmpt, childValueData);
                        cmpt.children.push(this.initComponent(childCmpt, childValueData));
                    }
                } else { //其他
                    this.initValueSingle(cmpt, valueData);
                }
            }
            return cmpt;
        },


        /**
         * 遍历控件添加到监听数据
         * dataList 目的表单
         * tableList 要添加的表单
         * valueList 值
         **/
        initValue(dataList, tableList, valueList) {
            console.log('initValue', dataList, tableList, valueList);
            for (let i = 0; i < tableList.length; i++) {
                let cmpt = tableList[i];
                let valueData = null;
                if (valueList && valueList[cmpt.props.id]) {
                    valueData = valueList[cmpt.props.id];
                }
                this.initValueSingle(cmpt, valueData);
                dataList.push(cmpt);
            }
        },

        /**
         * 初始化单个基础控件
         * @param cmpt
         * @param valueData
         */
        initValueSingle(cmpt, valueData) {
            if (valueData) {
                if (cmpt.componentName == RelateField) {
                    if (valueData.length > 0) {
                        for (let i = 0; i < valueData.length; i++) {
                            let tempValue = valueData[i];
                            if (!tempValue.statusCd) {
                                tempValue.statusCd = '';
                            }
                        }
                        cmpt.value = valueData;
                    } else {
                        cmpt.value = [];
                    }
                } else if (cmpt.componentName == PurchaseQuotedPriceField) {
                    cmpt.value = valueData;
                    if (!cmpt.value['quotationResult']) {
                        cmpt.value['quotationResult'] = {};
                    }
                } else {
                    // 处理 content中垃圾数据
                    if (['Attachment', 'PhotoField'].includes(cmpt.componentName)) {
                        console.log('initValueSingle 3', valueData);
                        if (typeof valueData === 'string') {
                            // valueData = [valueData];
                            valueData = JSON.parse(valueData);
                        }
                        valueData = valueData.map(m => {
                            delete m.url;
                            return {
                                ...m,
                                url: this.getFileLink(m.fileId)
                            };
                        });
                    }
                    cmpt.value = valueData;
                }
            } else {
                if (cmpt.componentName == TextField ||
                    cmpt.componentName == NumberField ||
                    cmpt.componentName == TextareaField ||
                    cmpt.componentName == SelectField ||
                    cmpt.componentName == MoneyField) {
                    cmpt.value = '';
                } else if (cmpt.componentName == DateField) {
                    cmpt.value = '';
                } else if (cmpt.componentName == TimeAndLocationField) {
                    cmpt.value = { address: '', isLoading: false };
                } else if (cmpt.componentName == DateRangeField) {
                    cmpt.value = ['', '', ''];
                } else if (cmpt.componentName == PurchaseQuotedPriceField) {
                    cmpt.value = {};
                    cmpt.value['quotationResult'] = {};
                } else {
                    cmpt.value = [];
                }
            }
        },

        /**
         * 初始化关联审批单的值
         * @param cmptList
         * @param value
         */
        initRelate(cmptList, value) {
            for (let i = 0; i < cmptList.length; i++) {
                let component = cmptList[i];
                let tempValue;
                if (value && value[component.props.id]) {
                    tempValue = value[component.props.id];
                } else {
                    continue;
                }

                if (component.componentName == 'RelateField') {
                    console.log('initRelate', component, tempValue);
                    this.initRelateStatusCd(tempValue);
                } else if (component.componentName == 'TableField') {
                    if (tempValue && tempValue.length) {
                        for (let j = 0; j < component.children.length; j++) {
                            let childComponent = component.children[j];
                            if (childComponent.componentName == 'RelateField') {
                                for (let k = 0; k < tempValue.length; k++) {
                                    let tempChildValue = tempValue[k][childComponent.props.id];
                                    console.log('initRelate', component, tempValue);
                                    this.initRelateStatusCd(tempChildValue);
                                }
                            }
                        }
                    }
                } else if (this.isSuiteCompnent(component.componentName)) {
                    this.initRelate(component.children, tempValue);
                }
            }
        },

        //获取关联审批单状态
        initRelateStatusCd(tempValue) {
            if (tempValue && tempValue.length) {

            } else {
                return;
            }
            for (let i = 0; i < tempValue.length; i++) {
                console.log('initRelateStatusCd', tempValue[i]);
                // if (!tempValue[i].statusCd) {
                tempValue[i].statusCd = '';
                let param = {
                    id: tempValue[i].id
                };
                let url = 'badu/eaa/queryApproveDetail.do';
                if (tempValue[i].approveType == 2) {
                    url = 'badu/eaa/queryApproveWorkFlowDetail_V2.do';
                }
                this.$http.post(url, param).then((response) => {
                    if (response.rspCode == 0) {
                        this.$nextTick(() => {
                            tempValue[i].statusCd = response.data.statusCd;
                        });
                    }
                }).catch((error) => {
                    console.log(i, error);
                });
                // }
            }
        }
    }
};

export default Mixins;

